import { render, staticRenderFns } from "./AccessError.vue?vue&type=template&id=53c50594&scoped=true&"
import script from "./AccessError.vue?vue&type=script&lang=js&"
export * from "./AccessError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c50594",
  null
  
)

export default component.exports